'use strict';

module.exports = {
  VARIABLES_ENVELOPE_TYPE: 'variable',
  FIXED_ENVELOPE_TYPE: 'fixed',
  RISEUP_GOAL_ENVELOPE_TYPE: 'riseupGoal',
  ROLLING_CREDIT_ENVELOPE_TYPE: 'rollingCredit',
  VARIABLE_INCOME_ENVELOPE_TYPE: 'variableIncome',
  ECONOMY_ENVELOPE_TYPE: 'economy',
  EXCLUDED_ENVELOPE_TYPE: 'excluded',
  VARIABLE_ENVELOPE_ID: 'variable',
  VARIABLE_INCOME_ENVELOPE_ID: 'variableIncome',
  DAY_FORMAT: 'YYYY-MM-DD',
  WEEK_TIMEFRAME: {
    PAST: 'past',
    CURRENT: 'current',
    FUTURE: 'future',
  },
  ENVELOPES_DEFAULT_DETAILS: {
    rollingCredit: {
      expense: 'אשראי מתגלגל',
      businessName: 'אשראי מתגלגל',
    },
  },
  TRACKING_FREQUENCY: {
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
  },
  RECURRING_ENVELOPE_TYPE: 'recurring',
  TRACKING_CATEGORY_ENVELOPE_TYPE: 'trackingCategory',
  ECONOMY_EXPENSE_CATEGORY: 'כלכלה',
  EXPENSE_FIELD_NAME: 'expense',

  EXCLUDED_REASONS: {
    CUSTOMER_RULE: 'customer_rule',
  },
  ENRICHMENT_INPUT_TYPES: {
    TRANSACTION_ID: 'transactionId',
    BUSINESS_NAME: 'businessName',
  },
  MATCH_BY_TYPE: {
    TRANSACTION_ID: 'transactionId',
    BUSINESS_NAME: 'businessName',
  },
  DEFAULT_FIXED_EXPENSE_CATEGORY: 'אחר',
};
